<template>
    <!--Contact One Start-->
    <section class="contact-one">
            <div class="container">
                <div class="contact-one__inne">
                    <ul class="list-unstyled contact-one__list">
                        <li class="contact-one__single">
                            <div class="contact-one__icon">
                                <span class="icon-phone-call"></span>
                            </div>
                            <div class="contact-one__content">
                                <p class="contact-one__sub-title">Teléfono</p>
                                <h3 class="contact-one__number"><a href="tel:963933691">+56 9-6393-3691</a></h3>
                            </div>
                        </li>
                        <li class="contact-one__single">
                            <div class="contact-one__icon">
                                <span class="icon-message"></span>
                            </div>
                            <div class="contact-one__content">
                                <p class="contact-one__sub-title">Enviar un Correo</p>
                                <h3 class="contact-one__number"><a
                                        href="mailto:iehelectricidad@gmail.com" target="_blank">iehelectricidad@gmail.com</a></h3>
                            </div>
                        </li>
                        <li class="contact-one__single">
                            <div class="contact-one__icon">
                                <span class="icon-location"></span>
                            </div>
                            <div class="contact-one__content">
                                <p class="contact-one__sub-title">Casablanca,</p>
                                <h3 class="contact-one__number">Chile</h3>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <!--Contact One End-->

</template>

<script>
</script>